var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "c-svg-sandbox",
    style: _vm.responsiveStyle,
    domProps: {
      innerHTML: _vm._s(
        require("!svg-inline-loader?removingTags[]=width&removingTags[]=height!@/assets/svg/" +
          _vm.src)
      ),
    },
    on: {
      click: function ($event) {
        return _vm.$emit("onClickHandle")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }